import axiosInstance from '../helpers/axios.helper';

const getStatisticsByCreator = (dates, options = {}) => {
  return axiosInstance.get('api/v2/reports/v2_options/statistics_by_creator', {params: dates}, options);
};

const getStatisticsByIndustry = (dates, options = {}) => {
  return axiosInstance.get('api/v2/reports/v2_options/statistics_by_industry', {params: dates}, options);
};

const getStatisticsBySender = (dates, options = {}) => {
  return axiosInstance.get('api/v2/reports/v2_options/statistics_by_sender', {params: dates}, options);
};

const getStatisticsBySenderIndustry = (dates, options = {}) => {
  return axiosInstance.get('api/v2/reports/v2_options/statistics_by_sender_industry', {params: dates}, options);
};

const getShareOptionsBySender = (dates, options = {}) => {
  return axiosInstance.get('api/v2/reports/v2_options/share_options_by_sender', {params: dates}, options);
};

export const v2OptionStatsService = {
  getStatisticsByCreator,
  getStatisticsByIndustry,
  getStatisticsBySender,
  getStatisticsBySenderIndustry,
  getShareOptionsBySender
};



// WEBPACK FOOTER //
// ./src/services/v2OptionStats.service.js